import PropTypes from "prop-types";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { Button, CircularProgress, Grid } from "@mui/material";
import { gridSpacing } from "../../../store/constants";
import TextField from "../../../utils/ui-components/FormsUI/TextField";
import { MaskListValues } from "./masks-list";
import { MaskService } from "../../../assets/_services/mask-service";
import { openSuccessDialog } from "../../../utils/ui-components/pop-ups/SuccessDialog";
import { useState } from "react";
import SwitchWrapper from "../../../utils/ui-components/FormsUI/Switch";
import SelectWrapper from "../../../utils/ui-components/FormsUI/Select";
import { UserService } from "../../../assets/_services/user-service";
import AutoCompleteSearchWrapper from "../../../utils/ui-components/FormsUI/AutoCompleteSearch";
import MultipleSelectCheckmarksWrapper from "../../../utils/ui-components/FormsUI/MultipleSelectCheckmarks";

RequestMask.propTypes = {
  initialItem: PropTypes.object.isRequired,
  setOpen: PropTypes.func.isRequired,
  fetchData: PropTypes.func,
  initialData: PropTypes.object,
};

function RequestMask({ initialItem, setOpen, fetchData }: any) {
  const [isLoading, setIsLoading] = useState(false);

  const FORM_VALIDATION = Yup.object().shape({
    maskName: Yup.string()
      .required("Please enter name for the mask")
      // .max(11, "Character count must not exceed 11.")
      .matches(/^[a-zA-Z0-9 .]+$/, "Only letters, numbers, spaces, and dots are allowed.")
      .trim("Enter valid name"),
    purpose: Yup.string().required("Please enter the purose of requesting"),
    activeStatus: Yup.boolean().required("Please select the mask status"),
    parentUser: Yup.object().required("Please enter the parent user").typeError("Please select the parent user"),
    operators: Yup.array()
      .of(
        Yup.object().shape({
          value: Yup.number().required("Operator is required"),
        }),
      )
      .min(1, "Operator is required"),
  });

  const createMask = (itemData: MaskListValues, setSubmitting: (isSubmitting: boolean) => void) => {
    console.log(itemData);
    setIsLoading(true);
    let formData = {
      maskName: itemData.maskName,
      ownerId: itemData.parentUser.value,
      systemOperatorId: itemData.operators.map((item: any) => item.value),
      purpose: itemData.purpose,
    };
    MaskService.addNewMask(formData).then((response) => {
      setSubmitting(false);
      if (response.isSuccess) {
        openSuccessDialog("Success", `Mask ${itemData.maskName} has been added successfully!`);
        setOpen(false);
        fetchData();
        setIsLoading(false);
      } else {
        setSubmitting(false);
        setIsLoading(false);
      }
    });
  };

  return (
    <Formik
      initialValues={{
        ...initialItem,
      }}
      validationSchema={FORM_VALIDATION}
      onSubmit={(values: MaskListValues, { setSubmitting }) => {
        createMask(values, setSubmitting);
      }}
    >
      {({ values, dirty, isSubmitting, isValid, setFieldValue }) => (
        <Form>
          <Grid container columnSpacing={gridSpacing}>
            <Grid item xs={12}>
              <AutoCompleteSearchWrapper
                // sx={{ mt: 1 }}
                disabled={false}
                freeSolo
                name={"parentUser"}
                label={"Parent User"}
                data={values}
                fetchData={async (value: any, data: any) => {
                  try {
                    let searchData: {
                      companyName: string;
                    };

                    if (typeof data.parentUser === "object" && value.value === data.parentUser?.label && typeof data.parentUser?.value === "number") {
                    } else if (value.value === "") {
                      return { isSuccess: true, data: [] };
                    } else {
                      searchData = {
                        companyName: String(value?.value),
                      };
                      const response = await UserService.searchOwnerByCompanyName(searchData);
                      if (response.isSuccess) {
                        const parents = response.data?.data?.map((e: any) => ({
                          label: `${e.companyName} (${e.userName})`,
                          value: e.ownerId,
                        }));
                        return { isSuccess: true, data: parents };
                      } else {
                        return { isSuccess: false, data: [] };
                      }
                    }
                  } catch (error) {
                    return { isSuccess: false, data: [] };
                  }
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField required type="text" name="maskName" label="Mask Name" />
            </Grid>
            <Grid item xs={12}>
              <MultipleSelectCheckmarksWrapper
                name="operators"
                label="Operators"
                options={[
                  { value: 1, label: "Robi" },
                  { value: 2, label: "Teletalk" },
                  { value: 3, label: "Banglalink" },
                  { value: 4, label: "Grameenphone" },
                ]}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField required type={"text"} name="purpose" label="Purpose" multiline={true} />
            </Grid>
            {initialItem?.id && (
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <SwitchWrapper name="activeStatus" label={values.activeStatus ? "ACTIVE" : "INACTIVE"} style={{ co: "green" }} />
              </Grid>
            )}
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  py: 2,
                }}
              >
                <Button color="primary" variant="contained" type="button" onClick={() => setOpen(false)} sx={{ mr: 1 }}>
                  Cancel
                </Button>
                <Button color="primary" variant="contained" type="submit" disabled={!dirty || isSubmitting || !isValid}>
                  {isLoading && <CircularProgress size={"20px"} sx={{ mr: 1, color: "gray" }} />} Add Mask
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
}

export default RequestMask;
